import CustomTabs from '../../../../../components/custom-tabs/CustomTabs';
import DownlaodOutboundForm from './DownloadForms/DownlaodOutboundForm';
import DownloadBatchReleaseCertificate from './DownloadForms/DownloadBatchReleaseCertificate';
import DownloadCARTForm from './DownloadForms/DownloadCARTForm';
import DownloadCOAForm from './DownloadForms/DownloadCOAForm';
import DownloadInboundForm from "./DownloadForms/DownloadInboundForm"
const TabsDetail = ({patientData, patientInfo}) => {

  const phasesData = [
    {
      id: 1,
      title: "Car-T Manufacturing",
      component: (<DownloadCARTForm patientData={patientData} patientInfo={patientInfo}/>)
    },
    {
      id: 2,
      title: "Batch Release certificate",
      component: (<DownloadBatchReleaseCertificate patientData={patientData} patientInfo={patientInfo}/>)
    },
    {
      id: 3,
      title: "Certificate of Analysis",
      component: (<DownloadCOAForm patientData={patientData} patientInfo={patientInfo} />)
    },
    {
      id: 4,
      title: "Out-Bound Form",
      component: (<DownlaodOutboundForm patientData={patientData} />)
    },
    {
      id: 5,
      title: "In-Bound Form",
      component: (<DownloadInboundForm patientData={patientData} />)
    },
  ];


  return (
    <CustomTabs
      phases={phasesData}
      activePhaseId={1} //@info default first one open
      // onPhaseChange={(id) => console.log("Active Tab:", id)}
      onPhaseChange={(id)=>{id}}
      isTabTitleOnly={true}
      renderPhaseContent={(phase) => (
        <div className="p-4">
          <h2 className="text-lg font-semibold">{phase.component}</h2>
        </div>
      )}
    />
  )
}

export default TabsDetail